export default __webpack_public_path__ + "static/media/atomic-one-logo.246d7880.png";